import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../offer_manage';

export default function Launcher(props) {
  const config = useDialogConfig();

  const offer = useConnect('offer.byId', {
    id: config.params.offerId
  });

  if (offer.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      offer={offer}
      onClose={props.onClose}
    />
  );
};
